import type Role from "./role";

export default class UserRole {
  id: string;
  role: Role;
}
